import http from "@/http-common";
import Customer, {CustomerDTO} from "@/api/Customer";
import CustomerName from "@/api/Customer/CustomerName";
import PostRequestInterface from "@/request/PostRequestInterface";
import CustomerEmail from "@/api/Customer/CustomerEmail";
import CustomerPassword from "@/api/Customer/CustomerPassword";
import CustomerMobile from "@/api/Customer/CustomerMobile";
import CustomerMobileVerifyRemaingTime from "@/api/Customer/CustomerMobileVerifyRemaingTime";
import CustomerNewsletter from "@/api/Customer/CustomerNewsletter";

class CustomerService {
    async getCurrentCustomer(): Promise<Customer> {
        const url = '/customer/ajaxCustomerInfo/current';
        const response = await http.get<CustomerDTO>(url);
        return new Customer(response.data);
    }

    async saveCustomerName(customerName: CustomerName): Promise<PostRequestInterface> {
        const url = '/customer/ajaxCustomerInfo/saveCustomerName';
        const formData = new FormData();
        formData.append('firstname', customerName.firstname);
        formData.append('lastname', customerName.lastname);
        const response = await http.post<PostRequestInterface>(url, formData);
        return response.data;
    }

    async saveCustomerEmail(customerEmail: CustomerEmail): Promise<PostRequestInterface> {
        const url = '/customer/ajaxCustomerInfo/saveCustomerEmail';
        const formData = new FormData();
        formData.append('email', customerEmail.email);
        const response = await http.post<PostRequestInterface>(url, formData);
        return response.data;
    }

    async saveCustomerPassword(customerPassword: CustomerPassword): Promise<PostRequestInterface> {
        const url = '/customer/ajaxCustomerInfo/saveCustomerPassword';
        const formData = new FormData();
        formData.append('currentPassword', customerPassword.currentPassword);
        formData.append('newPassword', customerPassword.newPassword);
        const response = await http.post<PostRequestInterface>(url, formData);
        return response.data;
    }

    async changeCustomerMobile(customerMobile: CustomerMobile): Promise<PostRequestInterface> {
        const url = '/customer/ajaxCustomerInfo/changeCustomerMobile';
        const formData = new FormData();
        formData.append('mobile', customerMobile.mobile);
        const response = await http.post<PostRequestInterface>(url, formData);
        return response.data;
    }

    async saveCustomerMobile(customerMobile: CustomerMobile): Promise<PostRequestInterface> {
        const url = '/customer/ajaxCustomerInfo/saveCustomerMobile';
        const formData = new FormData();
        formData.append('mobile', customerMobile.mobile);
        formData.append('verificationCode', customerMobile.verificationCode);
        const response = await http.post<PostRequestInterface>(url, formData);
        return response.data;
    }

    async getActivationRemainingTime(): Promise<CustomerMobileVerifyRemaingTime> {
        const url = '/customer/ajaxCustomerInfo/getActivationRemainingTime';
        const response = await http.get<CustomerMobileVerifyRemaingTime>(url);
        return response.data;
    }

    async resendActivationCode(): Promise<PostRequestInterface> {
        const url = '/customer/ajaxCustomerInfo/resendActivationCode';
        const response = await http.get<PostRequestInterface>(url);
        return response.data;
    }

    async saveCustomerNewsletter(customerNewsletter: CustomerNewsletter): Promise<PostRequestInterface>{
        const url = '/customer/ajaxCustomerInfo/saveCustomerNewsletter';
        const formData = new FormData();
        formData.append('isSubscribed', customerNewsletter.isSubscribed? '1' : '0');
        const response = await http.post<PostRequestInterface>(url, formData);
        return response.data;
    }

    async uploadCustomerImage(image: File): Promise<PostRequestInterface> {
        const url = '/customerimage/index/upload';
        const formData = new FormData();
        formData.append('image', image);
        const response = await http.post<PostRequestInterface>(url, formData);
        return response.data;
    }

    async deleteCustomerImage(): Promise<PostRequestInterface> {
        const url = '/customerimage/index/delete';
        const formData = new FormData();
        formData.append('delete', '1');
        const response = await http.post<PostRequestInterface>(url, formData);
        return response.data;
    }
}

export default new CustomerService();